// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2DE1t","title":"Images90_title__UrCHR","images":"Images90_images__2X2o6"};